export function maskVerificationId(id: string) {
  const visiblePart = id.slice(0, 5); // get first 5 characters
  const maskedPart = "*".repeat(id.length - 5); // mask the rest
  return visiblePart + maskedPart;
}
